import type { Location } from "../lib/types";
import { useLocale } from "../lib/i18n";

function label(loc: Location): string {
  const parts = [loc.city, loc.admin, loc.country].filter(Boolean);
  return parts.join(", ");
}

export function GeoSwitchBanner(props: {
  current: Location;
  suggested: Location;
  onAccept: () => void;
  onDismiss: () => void;
}) {
  const { t } = useLocale();
  return (
    <div className="card geoBanner" role="status" aria-live="polite">
      <div className="geoBannerText">
        <div className="geoBannerTitle">{t.locationChangeDetected}</div>
        <div className="geoBannerSub">
          {t.showing}: <b>{label(props.current)}</b> • {t.detected}: <b>{label(props.suggested)}</b>
        </div>
      </div>

      <div className="geoBannerActions">
        <button className="btn" onClick={props.onAccept}>{t.switchBtn}</button>
        <button className="btn" onClick={props.onDismiss}>{t.keepBtn}</button>
      </div>
    </div>
  );
}
